(function () {
  const wrapper = document.querySelector('[data-coloo-quiz]');
  if (!wrapper) return;

  const questions = JSON.parse(wrapper.dataset.questions || '[]');
  const results = JSON.parse(wrapper.dataset.results || '[]');
  const questionEls = wrapper.querySelectorAll('.ctm-block-choice-quiz__question');
  const dots = wrapper.querySelectorAll('.ctm-block-choice-quiz__dot');
  const resultEls = wrapper.querySelectorAll('.ctm-block-choice-quiz__result');
  const nav = wrapper.querySelector('.ctm-block-choice-quiz__nav');
  const counter = wrapper.querySelector('.ctm-block-choice-quiz__counter');
  const scores = [];

  function updateCounter(index) {
    if (counter) {
      counter.textContent = 'Vraag ' + (index + 1) + ' van ' + questions.length;
    }
  }

  function showQuestion(index) {
    questionEls.forEach(function (q, i) {
      q.classList.remove('active', 'slide-in-left', 'slide-in-right');
      if (i === index) {
        q.classList.add('active');
      }
    });
    dots.forEach(function (d, i) {
      d.classList.toggle('active', i <= index);
    });
    updateCounter(index);

    var activeQ = questionEls[index];
    if (activeQ) {
      var firstOption = activeQ.querySelector('.ctm-block-choice-quiz__option');
      if (firstOption) firstOption.focus();
    }
  }

  function animateToQuestion(index, direction) {
    var current = wrapper.querySelector('.ctm-block-choice-quiz__question.active');
    if (current) current.classList.remove('active');

    var next = questionEls[index];
    if (next) {
      next.classList.add(
        'active',
        direction === 'forward' ? 'slide-in-right' : 'slide-in-left',
      );
    }
    dots.forEach(function (d, i) {
      d.classList.toggle('active', i <= index);
    });
    updateCounter(index);

    if (next) {
      var firstOption = next.querySelector('.ctm-block-choice-quiz__option');
      if (firstOption) firstOption.focus();
    }
  }

  function findResult(total) {
    for (var i = 0; i < results.length; i++) {
      if (total >= results[i].minScore && total <= results[i].maxScore) {
        return results[i].id;
      }
    }
    return results.length ? results[0].id : '';
  }

  function showResult() {
    var total = scores.reduce(function (a, b) {
      return a + b;
    }, 0);
    var resultId = findResult(total);

    questionEls.forEach(function (q) {
      q.classList.remove('active', 'slide-in-left', 'slide-in-right');
    });
    nav.style.display = 'none';

    resultEls.forEach(function (r) {
      var isMatch = r.dataset.result === resultId;
      r.classList.toggle('active', isMatch);
      if (isMatch) {
        var cta = r.querySelector('.ctm-block-choice-quiz__cta');
        if (cta) cta.focus();
      }
    });

    document.dispatchEvent(
      new CustomEvent('coloo:quiz:result', {
        detail: { total: total, resultId: resultId, scores: scores.slice() },
      }),
    );
  }

  function restart() {
    scores.length = 0;
    resultEls.forEach(function (r) {
      r.classList.remove('active');
    });
    nav.style.display = '';

    wrapper
      .querySelectorAll('.ctm-block-choice-quiz__option')
      .forEach(function (btn) {
        btn.setAttribute('aria-checked', 'false');
        btn.classList.remove('selected');
      });

    showQuestion(0);

    document.dispatchEvent(new CustomEvent('coloo:quiz:restart'));
  }

  function goBack() {
    if (scores.length === 0) return;
    scores.pop();

    var prevIndex = scores.length;
    var prevQuestion = questionEls[prevIndex];
    if (prevQuestion) {
      prevQuestion
        .querySelectorAll('.ctm-block-choice-quiz__option')
        .forEach(function (btn) {
          btn.setAttribute('aria-checked', 'false');
          btn.classList.remove('selected');
        });
    }

    animateToQuestion(prevIndex, 'backward');
  }

  wrapper
    .querySelectorAll('.ctm-block-choice-quiz__option')
    .forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.setAttribute('aria-checked', 'true');
        btn.classList.add('selected');

        var siblings = btn.parentNode.querySelectorAll(
          '.ctm-block-choice-quiz__option',
        );
        siblings.forEach(function (s) {
          if (s !== btn) {
            s.setAttribute('aria-checked', 'false');
            s.classList.remove('selected');
          }
        });

        scores.push(parseInt(btn.dataset.score, 10));

        if (scores.length < questions.length) {
          animateToQuestion(scores.length, 'forward');
        } else {
          showResult();
        }
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });

  wrapper
    .querySelectorAll('.ctm-block-choice-quiz__back')
    .forEach(function (b) {
      b.addEventListener('click', goBack);
    });

  wrapper
    .querySelectorAll('.ctm-block-choice-quiz__restart')
    .forEach(function (b) {
      b.addEventListener('click', restart);
    });
})();
